import { Controller } from "@hotwired/stimulus";
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';

export default class extends Controller {

  connect() {
    this.initOneItemSwiper();
  }

  initOneItemSwiper() {
    const element = this.element;

    const indicators = this.element.querySelector('.indicators');
    const nextBtn = this.element.querySelector('.next');
    const prevBtn = this.element.querySelector('.prev');

    this.oneItemSwiper = new Swiper(this.element, {
      modules: [Navigation, Pagination],
      autoHeight: true,
      loop: true,
      pagination: {
        el: indicators,
        clickable: true,
        renderBullet: function (index, className) {
          return `<span class="${className} indicator-dot"></span>`;
        }
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      on: {
        slideChange: function() {
          const activeIndex = this.realIndex; 
          const colors = ['#E7ECEE', '#E9DECA', '#E2D6E5', '#D4D8E4'];
          const parentDiv = element;
          parentDiv.style.backgroundColor = colors[activeIndex % colors.length];
        }
      },
    });
  }
}